import React from 'react';
import { Coffee } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-400 py-12 border-t border-gray-900" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-75">
          <div className="flex items-center gap-2" data-id="element-76">
            <div className="text-gray-500" data-id="element-77">
              <Coffee size={24} data-id="element-78" />
            </div>
            <span className="font-bold text-xl tracking-tight text-white" data-id="element-79">
              LATTEWARE
            </span>
          </div>

          <div className="flex gap-8 text-sm" data-id="element-80">
            <a href="#" className="hover:text-white transition-colors" data-id="element-81">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-82">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-83">
              Contact
            </a>
          </div>
        </div>

        <div className="mt-8 text-center md:text-left text-sm text-gray-600" data-id="element-84">
          &copy; {new Date().getFullYear()} Latteware, Inc. All rights reserved.
        </div>
      </div>
    </footer>;
}